export const roadmapSkills = [
    {
        id: 1,
        name: "Core Component Library",
        description: "149 copy-paste React Native components with TypeScript, NativeWind/Uniwind, and rn-primitives",
        category: "AniUI",
        timeline: "Q1 2025",
        icon: "📦"
    },
    {
        id: 2,
        name: "@aniui/cli",
        description: "init, add, blocks, themes, and registry installs for Expo and bare React Native",
        category: "Tooling",
        timeline: "Q2 2025",
        icon: "⚙️"
    },
    {
        id: 3,
        name: "shadcn / RNR Registry",
        description: "Install AniUI via aniui.dev/r with shadcn CLI and React Native Reusables",
        category: "Ecosystem",
        timeline: "Q2 2025",
        icon: "🔗"
    },
    {
        id: 4,
        name: "AniUI Pro",
        description: "Premium screen templates, blocks, and boilerplates for production mobile apps",
        category: "Product",
        timeline: "Q3 2025",
        icon: "✨"
    },
    {
        id: 5,
        name: "Charts & Data Viz",
        description: "Mobile chart components and dashboard blocks for analytics-heavy apps",
        category: "Components",
        timeline: "Q3 2025",
        icon: "📊"
    },
    {
        id: 6,
        name: "AniUI Academy",
        description: "Interactive courses with live playgrounds — JavaScript, React, React Native, system design",
        category: "Education",
        timeline: "Q4 2025",
        icon: "🎓"
    },
    {
        id: 7,
        name: "Figma UI Kit",
        description: "Design tokens and components aligned with AniUI for design-dev parity",
        category: "Design",
        timeline: "Q1 2026",
        icon: "🎨"
    },
    {
        id: 8,
        name: "Premium Blocks",
        description: "Full auth, settings, chat, and commerce screen layouts out of the box",
        category: "AniUI",
        timeline: "Q1 2026",
        icon: "🧱"
    },
    {
        id: 9,
        name: "AniUI Studio",
        description: "AI-assisted workflows for composing screens and exploring the component catalog",
        category: "AI",
        timeline: "Q2 2026",
        icon: "🤖"
    },
    {
        id: 10,
        name: "Mobile App Portfolio",
        description: "Ship consumer apps (Uncover Us, Collega, Roamly) built on the AniUI stack",
        category: "Apps",
        timeline: "Q2 2026",
        icon: "📱"
    },
    {
        id: 11,
        name: "Documentation & DX",
        description: "Deep docs, migration guides, and zero-setup paths for existing RNR projects",
        category: "Community",
        timeline: "Q3 2026",
        icon: "📚"
    },
    {
        id: 12,
        name: "Enterprise Patterns",
        description: "Theming, monorepo recipes, and accessibility checklists for teams at scale",
        category: "AniUI",
        timeline: "Q4 2026",
        icon: "🏢"
    }
];
